import { QueryFunctionContext } from '@tanstack/react-query'
import { ProductCatalogPricingService } from 'shared/services/ProductCatalogPricingService'
import { CHOICE_GROUP_BATCH_SIZE } from '~/app/constants'
import type { PCT } from 'shared/types/vp/pct'

export const QUERY_KEY = 'differential_pricing'

export const queryBatchDifferentialPricing = async (
  context: QueryFunctionContext<PCT.Queries.ProductCatalogPricingService.DifferentialPriceQueryKey>,
): Promise<PCT.Models.ProductCatalogPricingService.DifferentialPricingResult | null> => {
  const { queryKey } = context
  const [_, { market, productKey, quantity, productVersion, choiceGroups, pricingContext, couponCode, effectiveDateTime, customerGroups, selections }] =
    queryKey

  const requests: Promise<PCT.Models.ProductCatalogPricingService.DifferentialPricingResult | null>[] = []

  const batchableChoiceGroups = Object.entries(choiceGroups || {})

  // Assigned 2 to CHOICE_GROUP_BATCH_SIZE as a hotfix to increase the no.of batches and reduce the request size
  for (let i = 0; i < batchableChoiceGroups.length; i += CHOICE_GROUP_BATCH_SIZE) {
    const batchedChoiceGroups = batchableChoiceGroups.slice(i, i + CHOICE_GROUP_BATCH_SIZE).reduce((result, [key, value]) => {
      result[key] = value

      return result
    }, {} as PCT.Models.ProductCatalogPricingService.ChoiceGroups)

    const batchedRequest = ProductCatalogPricingService.getDifferentialPrice(
      market,
      productKey,
      quantity,
      productVersion,
      batchedChoiceGroups,
      pricingContext,
      couponCode,
      effectiveDateTime,
      customerGroups,
      selections,
    )

    requests.push(batchedRequest)
  }

  const responses = await Promise.all(requests)

  const responsesChoiceGroups = responses.reduce(
    (accum, response) => ({
      ...accum,
      ...response?.choiceGroups,
    }),
    {} as Promise<PCT.Models.ProductCatalogPricingService.ChoiceGroupsPricing | null>,
  )

  return {
    ...responses.reduce(
      (accum, response) => ({
        ...accum,
        ...response,
      }),
      {} as Promise<PCT.Models.ProductCatalogPricingService.DifferentialPricingResult | null>,
    ),
    choiceGroups: responsesChoiceGroups,
  }
}
